module.exports = __webpack_public_path__ + "static/media/MSME_Needs_21-11-2023__1_-removebg-preview.8d72404f.png";